
import React from "react";
import { useParams } from "react-router-dom";
import { PremiumBotForm } from "@/components/admin/premium-bots/PremiumBotForm";

const PremiumBotEditPage = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Error: Bot ID is required</div>;
  }

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Edit Premium Bot</h1>
      </div>
      
      <PremiumBotForm botId={id} isEdit={true} />
    </div>
  );
};

export default PremiumBotEditPage;
